import React, {useMemo} from 'react';
import CheckedInOperatorText from "../../checkin3/CheckedInOperatorText";
import {useForm, Controller} from "react-hook-form";
import PressPalletIcon from "../PressPalletIcon";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {TextField} from '@material-ui/core';
import * as yup from "yup";
import {yupResolver} from '@hookform/resolvers';
import {makeStyles} from "@material-ui/core/styles";
import {getCurrentPressPallet, operatorExists, onStartPallet} from './PalletBuilderController';
import BaseAdHocPage from "../../../framework/util/uicomps/BaseAdHocPage";
import PalletBuilderSuperStore from "../../stores/PalletBuilderSuperStore";


const validationStartBuilding = yup.object({
    loadOperatorId: yup.string().required().test('personId', 'Operator id does not exist', operatorExists),
    palletId: yup.string().required()
});


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));


const BuildPalletUINoPalletBuilding = ({currentState, sendEvent}) => {

    const [error, setError] = React.useState(null);
    const [saving, setSaving] = React.useState(false);

    const {register, handleSubmit, errors} = useForm({
        resolver: yupResolver(validationStartBuilding)
    });

    // Handle case where pallet is already loaded

    const classes = useStyles();

    const onSubmit = async data => {
        sendEvent("PALLETSTARTED", data);
    };


    const baseContentItems = [
        (<Grid item xs={12}>
                <CheckedInOperatorText inputRef={register} useReactHookForms={true} name={'loadOperatorId'}
                                       autofocus={true}
                                       error={errors.loadOperatorId ? true : false}
                                       fullWidth
                                       errorMessage={errors.loadOperatorId?.message}
                />
            </Grid>
        ),
        (<React.Fragment>
                <Grid item xs={12}>
                    <TextField label='Pallet Id'
                               helperText={errors.palletId ? errors.palletId?.message : 'Scan a pallet barcode'}
                               inputRef={register}
                               size={'small'}
                               fullWidth
                               name={'palletId'} error={errors.palletId ? true : false} variant={'outlined'}/>
                </Grid>

            </React.Fragment>
        )
    ];

    const buttonItems = [
        (<Button type="submit" variant="contained" color="primary" disabled={saving} fullWidth>
            Load Pallet
        </Button>)
    ];


    const Page = (
        <form onSubmit={handleSubmit(onSubmit)}>
            <BaseAdHocPage icon={<PressPalletIcon/>} title={'Pallet Not Loaded'}
                           description={'Scan a pallet and click below to load.'} buttons={buttonItems}
                           content={baseContentItems}/>
        </form>
    );

    const PageInGrid = (

        <Grid container
              direction="row"
              justify="center"
              alignItems="center"
        >
            <Grid item xs={2}>
            </Grid>
            <Grid item xs={8}>
                {Page}
            </Grid>
            <Grid item xs={2}>
            </Grid>
        </Grid>

    );


    return PageInGrid;




}

export default BuildPalletUINoPalletBuilding;